import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import {
  formatNumber,
  formatPercNumber,
} from '../../../../utils/formatting/number-formatter.helper';

interface ScenarioPlannerNumberCellTooltipComponentProps {
  formattedValue: string;
  data: any;
  className?: string;
}

export const ScenarioPlannerNumberCellTooltipComponent = ({
  formattedValue,
  data,
  className,
}: ScenarioPlannerNumberCellTooltipComponentProps) => {
  const bupChgPct = data['bup_CHG_PCT'] ?? 0;
  const apupRawCurrent = data['apup_RAW_CURRENT'] ?? 0;
  const apupInternalCurrent = data['apup_INTERNAL_CURRENT'];
  const isModified = Math.abs(apupInternalCurrent - apupRawCurrent) > 0.00001;
  const classNameStr = `${className ?? ''}${isModified ? ' is-indirect-modified clickable' : ''}`;
  return (
    <OverlayTrigger
      trigger={'click'}
      placement="auto"
      show={isModified ? undefined : false}
      overlay={
        <Tooltip className="scenario-planner-number-cell-tooltip">
          <p>
            Promo Price per Unit updated to{' '}
            {formatNumber(
              apupInternalCurrent,
              {
                maximumFractionDigits: 2,
                minimumFractionDigits: 0,
              },
              '$',
            )}{' '}
            based on the {formatPercNumber(bupChgPct * 100)}% Base Price change.
            The original promo price was{' '}
            {formatNumber(
              apupRawCurrent,
              {
                maximumFractionDigits: 2,
                minimumFractionDigits: 0,
              },
              '$',
            )}
            .
          </p>
          <p>
            To change the promotion depth, enter a new unit price or switch to
            Depth of Discount and adjust depth after the base price change.
          </p>
        </Tooltip>
      }
    >
      <div className={classNameStr}>{formattedValue}</div>
    </OverlayTrigger>
  );
};
